module.exports = __webpack_public_path__ + "img/202411_10.447a523b.jpg";